import { render, staticRenderFns } from "./StudentMark.vue?vue&type=template&id=d118b650&scoped=true"
import script from "./StudentMark.vue?vue&type=script&lang=js"
export * from "./StudentMark.vue?vue&type=script&lang=js"
import style0 from "./StudentMark.vue?vue&type=style&index=0&id=d118b650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d118b650",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VSimpleTable})
